import { routes, useFlag } from '@sketch/modules-common'
import React from 'react'
import { Route, Switch } from 'react-router'
import {
  InboxSidebar,
  SettingsSidebar,
  Sidebar as NewSidebar,
} from '../Sidebar'
import { WorkspaceMinimalFragment } from '@sketch/gql-types'

interface WorkspaceSidebarProps {
  workspace: WorkspaceMinimalFragment
}

export const WorkspaceSidebar = ({ workspace }: WorkspaceSidebarProps) => {
  const isBetterNotificationsEnabled = useFlag('better-notifications')

  return (
    <Switch>
      <Route
        path={[
          routes.WORKSPACE_SETTINGS.template(),
          routes.PERSONAL_SETTINGS.template(),
        ]}
        render={() => <SettingsSidebar workspace={workspace} />}
      />
      {isBetterNotificationsEnabled && (
        <Route
          path={[routes.UPDATES_READ.template(), routes.UPDATES.template()]}
          render={() => <InboxSidebar workspace={workspace} />}
        />
      )}
      <Route render={() => <NewSidebar workspace={workspace} />} />
    </Switch>
  )
}
